import { Button, Form, Input, Modal } from "antd";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import styles from "./create.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { testImage } from "utils";
import { ResponseDataType, postRequest } from "api";
import { IconButton } from "@mui/material";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";

interface CreateOrgDataType {
  organizationId: string;
  memberId: string;
  departmentId: string;
}

export const CreateOrganization = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const CreateOrganization = (value: {
    name: string;
    logo: string;
    ownerName: string;
    phone?: string;
    avatar?: string;
  }) => {
    Modal.confirm({
      style: { fontFamily: "Quicksand" },
      title: "Xác nhận tạo tổ chức mới?",
      async onOk() {
        const response: ResponseDataType<CreateOrgDataType> = await postRequest(
          "/organization/create",
          {
            name: value.name,
            logo: value.logo,
            ownerId: localStorage.getItem("customerId"),
            ownerName: value.ownerName,
            phone: value.phone,
            avatar: value.avatar,
          }
        );

        if (response.code) {
          if (typeof response.message === "object") {
            response.message.forEach((message: string) => toast.error(message));
          } else toast.error(response.message);
        } else {
          toast.success("Tạo tổ chức thành công");
          const newOrgId = response.data?.organizationId as string;
          localStorage.setItem("organizationId", newOrgId);
          console.log(newOrgId);
          navigate(`/member-list?orgId=${newOrgId}`);
        }
      },
    });
  };

  return (
    <div className={styles.createorg_page}>
      <div className={styles.content}>
        <div className={styles.form_header}>
          <div className={styles.name}>Tạo tổ chức</div>
          <IconButton
            sx={{
              color: "black",
              pt: "0px",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
            onClick={() => {
              navigate("/");
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <Form
          requiredMark={false}
          className={styles.form}
          form={form}
          onFinish={CreateOrganization}
          layout="vertical"
        >
          <Form.Item
            label="Tên tổ chức"
            name="name"
            rules={[{ required: true, message: "Cần nhập tên tổ chức!" }]}
            className={styles.text}
          >
            <Input className={styles.input} placeholder="Tên tổ chức" />
          </Form.Item>

          <Form.Item
            className={styles.text}
            label="Logo tổ chức"
            name="logo"
            rules={[
              () => ({
                async validator(_, value) {
                  if (!value) return Promise.resolve();
                  var checkFlag;
                  try {
                    checkFlag = await testImage(value, 2000);
                  } catch (error) {
                    checkFlag = false;
                  }
                  if (checkFlag) {
                    return Promise.resolve();
                  } else return Promise.reject("Link logo lỗi!");
                },
              }),
            ]}
          >
            <Input
              className={styles.customInputWrapper}
              placeholder="Logo tổ chức"
              suffix={<UploadOutlinedIcon />}
            />
          </Form.Item>

          <Form.Item
            className={styles.text}
            label="Tên thành viên"
            name="ownerName"
            rules={[{ required: true, message: "Cần nhập tên thành viên" }]}
          >
            <Input className={styles.input} placeholder="Tên thành viên" />
          </Form.Item>

          <Form.Item
            className={styles.text}
            label="Số điện thoại thành viên"
            name="phone"
          >
            <Input className={styles.input} placeholder="Số điện thoại" />
          </Form.Item>

          <Form.Item
            className={styles.text}
            label="Avatar thành viên"
            name="avatar"
            rules={[
              () => ({
                async validator(_, value) {
                  if (!value) return Promise.resolve();
                  var checkFlag;
                  try {
                    checkFlag = await testImage(value, 3000);
                  } catch (error) {
                    checkFlag = false;
                  }
                  if (checkFlag) {
                    return Promise.resolve();
                  } else return Promise.reject("Link avatar lỗi!");
                },
              }),
            ]}
          >
            <Input
              className={styles.customInputWrapper}
              placeholder="Avatar thành viên"
              suffix={<UploadOutlinedIcon />}
            />
          </Form.Item>

          <div>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.buttom_submit}
            >
              TẠO TỔ CHỨC
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
